<template>
  <div class="case-creation__card mb-15">
    <div class="case-creation__heading">
      <div class="title-with-icon">
        <span class="icon">
          <img src="@/assets/images/icons/icon-test-info.svg" alt="icon" class="img-fluid" />
        </span>
        <h3 class="title">TEST TUBES INFORMATION</h3>
      </div>
    </div>
    <div class="case-creation__body">
      <div class="billing-information-tabs">
        <div class="tube-scroll-wrapper">
          <div v-if="tubeInfo.length">
            <div class="tube-header">
              <div class="tube-column">Test Tube</div>
              <div class="tube-column">Status</div>
              <div class="tube-column">Test Information</div>
            </div>
            <div class="tube-cards-block">
              <div class="tube-card" v-for="(tube, index) in tubeInfo" :key="index">
                <div class="tube-column img-block">
                  <div class="test-tube-img-block">
                    <img :src="getDownloadUrl(tube.image_url)" alt="Test Tube" width="100%" height="100%" />
                  </div>
                  <p class="tube-name">{{ tube.tube_name }}</p>
                </div>

                <div class="tube-column">
                  <el-select v-model="tube.status" placeholder="Status" size="small">
                    <el-option :label="tube.status" :value="tube.status" />
                  </el-select>
                </div>

                <div class="tube-column">
                <el-select
                  v-model="tube.collected_tests"
                  multiple
                  collapse-tags
                  size="small"
                  :filterable="false"
                  :clearable="false"
                  style="width: 200px !important;"
                >
                  <el-option
                    v-for="(testName, i) in tube.collected_tests"
                    :key="i"
                    :label="testName"
                    :value="testName"
                    :disabled="true" 
                  />
                </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PendingCaseTestTubesView",
  computed: {
    ...mapGetters("pendingCases", ["getsinglePatientDetails"]),
    tubeInfo() {
      return this.getsinglePatientDetails?.test_tube_information || [];
    },
  },
  watch: {
    tubeInfo: {
      immediate: true,
      handler(newData) {
        newData.forEach((tube) => {
          if (!tube?.image_url) return;
          // Decode the full URL
          const decodedUrl = decodeURIComponent(tube.image_url);
          // Extract the path after .com/
          const path = decodedUrl.split(".com/")[1];
          if (path) {
            // Keep only up to .png (or other image extension if needed)
            const cleanPath = path.split(".png")[0] + ".png";
            // Dispatch with clean path
            this.$store.dispatch("testTubesImageGeneration/fetchDownloadUrl", cleanPath);
            // Get from store with the same clean path
            const storeUrl = this.$store.getters["testTubesImageGeneration/getDownloadUrlByPath"](cleanPath);
            return storeUrl;
          }
        });
      },
    },
  },
  methods: {
    getDownloadUrl(imageUrl) {
      if (!imageUrl) return "";
      try {
        // Decode entire URL first
        const decodedUrl = decodeURIComponent(imageUrl);
        const path1 = decodedUrl.split(".com/")[1];
        const cleanPath = path1.split(".png")[0] + ".png";
        const storeUrl = this.$store.getters["testTubesImageGeneration/getDownloadUrlByPath"](cleanPath);
        return storeUrl;
      } catch (e) {
        console.error("Failed to decode or fix URL:", e);
        return imageUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.case-creation__card {
  margin-top: 1px;
  overflow-x: auto;
}
.case-creation__body {
  padding: 0;
}
.case-creation__heading .title {
  font-weight: bold;
}
.tube-scroll-wrapper {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  width: 100%;
}
.tube-header {
  display: flex;
  padding: 5px 20px;
  border-bottom: 1px solid #e7e7f7;
}
.tube-column {
  flex: 1;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 5px;
  .test-tube-img-block {
    width: 40px;
    height: 40px;
    padding: 0.5rem;
    border: 1px solid #e7e7f7;
    border-radius: 6px;
  }
  .tube-name {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }
  &.img-block {
    column-gap: 1rem;
  }
}
.tube-cards-block {
  max-height: 235px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8;
  }
  .tube-card {
    display: flex;
    padding: 5px 0px;
    margin: 0 20px;
    border-bottom: 1px solid #e7e7f7;
    &:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
.el-select {
  width: 160px !important;
  font-size: 12px;
} 
:deep(.el-tag__close) {
  display: none !important;
}
:deep(.el-select .el-input__inner) {
  background-color: #f9f9f9;
  color: #000;
  font-weight: 500;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #f9f9f9;
}
:deep(.el-select .el-input__suffix .el-input__icon) {
  color: #000000;
}
:deep(.el-select .el-input__inner::placeholder) {
  color: #000 !important;
  font-weight: 500 !important;
}
:deep(.el-select__tags-text) {
  color: #000 !important;
  font-weight: 500 !important;
}
.error-text {
  color: #f24a55;
  font-size: 11px;
  margin-top: 4px;
  text-align: left;
}
</style>
